import { observable, action, configure, makeAutoObservable } from 'mobx';

import reportService from '../service/reportServices';

configure({
  enforceActions: 'always',
});

export default class reportStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      fileType: observable,
      pageLength: observable,
      total: observable,
      currentPage: observable,
      reportList: observable,
      showDayEmpty: observable,
      isLoading: observable,
      setFileType: action,
      getReportList: action,
      getReportDownloadInfo: action,
      changePageNum: action,
      refreshReportListWithDate: action,
    });

    this.rootStore = rootStore;
  }

  // 报告类型，1：日报告，2：周报告，3：季度报告
  fileType = 1;

  // 分也时每页条数
  pageLength = 7;

  // 报告总条数
  total = 0;

  // 当前选择的页数
  currentPage = 1;

  // 报告列表
  reportList = [];

  // 是否显示日报告空信息
  showDayEmpty = false;

  // 判断结果是否已返回
  isLoading = false;

  // 设置当前报告类型
  setFileType = (type) => {
    this.fileType = type;
    this.currentPage = 1;
    this.pageLength = 7;
    this.total = 0;
    this.reportList = [];
    this.showDayEmpty = false;
    this.isLoading = false;
    if (type !== 1) {
      this.isLoading = true;
      this.refreshReportListWithDate(undefined, undefined);
    }
  };

  // 获取报告列表
  getReportList = (params) => {
    this.isLoading = true;
    reportService
      .getReportList(params)
      .then(
        action((res) => {
          this.isLoading = false;
          if (res.code !== 0) {
            return;
          }
          const data = res.data;
          this.currentPage = data.currentPage;
          this.pageLength = data.pageLength;
          this.total = data.total;
          this.reportList = data.list;
          this.showDayEmpty = data.list.length === 0;
        })
      )
      .catch(() => {});
  };

  // 获取报告下载数据
  getReportDownloadInfo = (item, errFunc) => {
    const fileId = item.id;
    const params = {
      id: fileId,
    };
    reportService
      .getReportDownloadInfo(params)
      .then(action(() => {}))
      .catch((res) => {
        if (
          res instanceof Error ||
          (typeof res === 'object' && res.status !== undefined)
        ) {
          errFunc({});
        } else {
          const textDecoder = new TextDecoder('utf-8');
          const uint8Array = new Uint8Array(res);
          let json;
          try {
            json = JSON.parse(textDecoder.decode(uint8Array));
            errFunc(json);
          } catch (e) {
            json = undefined; // avoid memory leak
            const result = res || {};
            if (result.code && result.code < 0) {
              return;
            }
            const blob = new Blob([result], {
              type: 'application/pdf',
              charset: 'utf-8',
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = item.fileName;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
              document.body.removeChild(a);
            }, 100);
          }
        }
      });
  };

  // 点击分页
  changePageNum = (pageNum, callBack) => {
    this.currentPage = pageNum;
    callBack && callBack();
  };

  refreshReportListWithDate = (startDate, endDate) => {
    const params = {
      fileType: this.fileType,
      currentPage: this.currentPage,
      pageLength: this.pageLength,
      start: startDate,
      end: endDate,
    };
    this.getReportList(params);
  };
}
